import React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useConfirm } from 'hooks';
import { Grid, Button } from '@material-ui/core';
import { Link } from 'react-router-dom';
import { buildUrl } from 'utils';
import { InvoiceActions } from 'state/modules/invoice';
import Can from 'components/Can';
import i18n from 'i18n-js';

const ReceivableActions = ({ id, options }) => {
  const dispatch = useDispatch();
  const { fetchingExportInvoice, fetchingSendEmailInvoice, loading } = useSelector(
    (state) => state.invoice
  );
  const receivableType = useSelector((state) => state.config?.settings?.core?.receivable?.type);

  const exportReceivable = () => {
    dispatch(InvoiceActions.fetchExportInvoice(id, receivableType));
  };

  const onProcessBalance = () => {
    dispatch(InvoiceActions.fetchProcessInvoiceById(id));
  };

  const sendReceivableByEmail = (subject) => {
    dispatch(InvoiceActions.fetchSendInvoiceByEmail(id, { subject }));
  };

  const onPublishInvoice = () => {
    dispatch(InvoiceActions.fetchPublishInvoice());
  };

  const [toggleSendInvoice, SendInvoice] = useConfirm({
    title: i18n.t('invoice.submit_title'),
    message: i18n.t('invoice.submit_msg'),
    cancelText: i18n.t('common.cancel'),
    confirmText: i18n.t('common.submit'),
    onConfirm: onPublishInvoice,
  });

  return (
    <Grid item>
      <SendInvoice />
      {options?.includes('submit') && (
        <Button
          color="primary"
          variant="outlined"
          onClick={toggleSendInvoice}
          style={{ textTransform: 'capitalize' }}
          data-cy="receivable-submit-btn"
        >
          {i18n.t('common.submit')}
        </Button>
      )}
      {options?.includes('preview') && (
        <Button
          component={Link}
          to={buildUrl(`/${receivableType}/${id}/preview`)}
          variant="outlined"
          color="primary"
          style={{ textTransform: 'capitalize', marginLeft: 10 }}
          data-cy="receivable-preview-btn"
        >
          {i18n.t(`receivable.${receivableType}_preview`)}
        </Button>
      )}
      {options?.includes('send_customer') && (
        <Button
          variant="outlined"
          onClick={() => sendReceivableByEmail('customer')}
          color="primary"
          disabled={fetchingSendEmailInvoice}
          data-cy="receivable-send-customer-btn"
          style={{ textTransform: 'capitalize', marginLeft: 10 }}
        >
          {i18n.t('receivable.send_customer')}
        </Button>
      )}
      {options?.includes('send_requester') && (
        <Button
          variant="outlined"
          onClick={() => sendReceivableByEmail('requester')}
          color="primary"
          disabled={fetchingSendEmailInvoice}
          data-cy="receivable-send-requester-btn"
          style={{ textTransform: 'capitalize', marginLeft: 10 }}
        >
          {i18n.t('receivable.send_requester')}
        </Button>
      )}
      {options?.includes('download') && (
        <Button
          variant="contained"
          onClick={exportReceivable}
          color="primary"
          disabled={fetchingExportInvoice}
          data-cy="receivable-download-btn"
          style={{ textTransform: 'capitalize', marginLeft: 10 }}
        >
          {i18n.t('common.download')}
        </Button>
      )}
      {options?.includes('process_balance') && (
        <Can I="process" a="receivable">
          <Button
            variant="contained"
            color="primary"
            disabled={loading}
            style={{ textTransform: 'capitalize', marginLeft: 10 }}
            onClick={onProcessBalance}
            data-cy="receivable-process-balance-btn"
          >
            {i18n.t('receivable.process_balance')}
          </Button>
        </Can>
      )}
    </Grid>
  );
};
export default ReceivableActions;
